<script setup lang="ts">
defineProps({
  vertical: { type: Boolean },
  horizontal: { type: Boolean },
  virtualHorizontal: { type: Boolean }
})

const { state: gestureState } = useGestures()
const { collectionScrollContainerId } = useGlobals()

function onScroll(x: number, y: number) {
  gestureState.value.mainView.scrollX = x
  gestureState.value.mainView.scrollY = y
}
</script>

<template>
  <interface-scrollbar
    :id="collectionScrollContainerId"
    :vertical
    :horizontal
    :virtual-horizontal
    size="md"
    @scroll="({ left: x, top: y }) => onScroll(x, y)"
  >
    <slot />
  </interface-scrollbar>
</template>
